import React from "react";
import "../About/about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component

const Procedure = () => {
  return (
    <div className="about-education">
      <Header />
      <main className="content">
        <section className="hero">
          <img
            src="Images/About/header.png"
            alt="Background"
            className="hero-image"
          />
          <div className="overlay">
            <h1 className="admission-title">
              Admission <br />
              Procedure
            </h1>
          </div>
        </section>

        <section className="text-content">

          <h2 style={{ fontWeight: "bold", marginTop: "20px", textAlign: "center" }}>
            Admission Procedure
          </h2>
          <ul>
            <li>
              <h3 style={{ fontSize: "1.1em", margin: "10px 0" }}>
                Application Forms
              </h3>
              Physical application forms will be available from the school
              office during the first week of November to the last week of
              December. Along with the form, the syllabus will be provided for
              the admission test. To avail the form.
            </li>
            <li>
              <h3 style={{ fontSize: "1.1em", margin: "10px 0" }}>
                Admission Test
              </h3>
              Students who have submitted their application forms will be
              invited to take an admission test in the first week of January.
            </li>
            {/* <li> */}
              {/* <h3 style={{ fontSize: "1.1em", margin: "10px 0" }}>
                Interview Round
              </h3>
              Students who pass the admission test will be called for an
              interview round along with their parents in the last week of
              January.
            </li> */}
        
            <li>
              <h3 style={{ fontSize: "1.1em", margin: "10px 0" }}>
                Admission List
              </h3>
              The final admission list will be announced and posted on the
              school noticeboard in the first week of March. Those candidates
              selected will also receive a telephonic call from the school
              office.
            </li>
            <li>
              <h3 style={{ fontSize: "1.1em", margin: "10px 0" }}>
                Commencement of Classes
              </h3>
              Scheduled for the first week of April.
            </li>
          </ul>
          <ul>
            <li>
              <b>
                The Principal reserves the right to refuse admission to any
                student without providing any explanation.
              </b>
            </li>
            <li>
              <b>A student is considered enrolled only after:</b>
              <ul>
                <li>Completing the admission procedure.</li>
                <li>Submitting all required documents.</li>
                <li>
                  Receiving the Admission Card signed by the Principal.
                </li>
              </ul>
            </li>
            <li>
              <b>
                Admission will not be granted without a verification and permission from the Principal.
              </b>
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Procedure;
